import { render, staticRenderFns } from "./VCostsGlobal.vue?vue&type=template&id=55b8bbf8&"
import script from "./VCostsGlobal.vue?vue&type=script&lang=js&"
export * from "./VCostsGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports